import React from 'react'
import { deviceDetect } from 'react-device-detect'

// Components
import MobVirConsultWrapper from './Mobile'
import NewBooking from '../../Bookings/components/AvailabilitySearchWrapper'
import SearchEngineWithProviders from '../../Search Engine'

const VirConsultWraper = () => {
  if (deviceDetect().isMobile) return <SearchEngineWithProviders isVirtualVisit={true} />
  else return <NewBooking isVirtualVisit={true} />
}

export default VirConsultWraper
